import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ListGroup, ListGroupItem, Panel, Checkbox } from 'react-bootstrap';
import { getActivityCodeDescendants } from '../../util/ActivityCodeLogic.jsx';

import { useStateValue } from '../../context/state.jsx';
import { setProjectFilterActivityCode } from '../../context/projectFilter.js';

const FilterByCodeItem = ({
	codeItem,
	filterOptions,
	projectFilter,
	projectActivityCodesRelativesMap
}) => {
	const [, dispatch] = useStateValue();
	const { name, children, childrenSequence } = codeItem;
	const hasChildren = Array.isArray(childrenSequence) && childrenSequence.length > 0;

	const childItems = hasChildren
		? childrenSequence.map(childGroupId => (
			<ListGroupItem key={childGroupId} className="codeTreeChildItem">
				<FilterByCodeItem
					codeItem={children[childGroupId]}
					filterOptions={filterOptions}
					projectFilter={projectFilter}
					projectActivityCodesRelativesMap={projectActivityCodesRelativesMap} />
			</ListGroupItem>
		))
		: null;

	let hasChildrenChecked = false,
		isChecked = false;
	if ('activityCodeId' in codeItem) {
		isChecked = codeItem.activityCodeTypeId in projectFilter.activityCodes &&
			codeItem.activityCodeId in projectFilter.activityCodes[codeItem.activityCodeTypeId];

		// If any descendants are checked, make this parent blue
		const descendants = getActivityCodeDescendants(codeItem.activityCodeId, projectActivityCodesRelativesMap.children[codeItem.activityCodeTypeId]);
		for (const descendantActivityCode in descendants) {
			if (codeItem.activityCodeTypeId in projectFilter.activityCodes && descendantActivityCode in projectFilter.activityCodes[codeItem.activityCodeTypeId]) {
				hasChildrenChecked = true;
				break;
			}
		}
	} else if (codeItem.activityCodeTypeId in projectFilter.activityCodes) {
		isChecked = true;
		const codes = filterOptions.activityCodeTypeActivityCodes[codeItem.activityCodeTypeId];
		for (let i = 0; i < codes.length; i++) {
			const code = codes[i];
			if (code in projectFilter.activityCodes[codeItem.activityCodeTypeId]) {
				hasChildrenChecked = true;
			} else {
				isChecked = false;
			}
		}
	}

	const onCheckboxClick = (event) => {
		event.stopPropagation();
		if ('activityCodeId' in codeItem) {
			dispatch(setProjectFilterActivityCode(codeItem.activityCodeId, codeItem.activityCodeTypeId, event.target.checked));
		} else {
			dispatch(setProjectFilterActivityCode(null, codeItem.activityCodeTypeId, event.target.checked));
		}
	};

	const checkbox = (
		<Checkbox
			inline
			checked={isChecked}
			onChange={() => null}
			onClick={onCheckboxClick}>
			&nbsp;
		</Checkbox>
	);

	// Leaves must not use Panel — RB Panel always renders an accordion chevron.
	if (!hasChildren) {
		return (
			<div className={classnames('codeTreeLeaf', { activeFilter: isChecked || hasChildrenChecked })}>
				{checkbox}
				<span className="codeTreeLeafName">{name}</span>
			</div>
		);
	}

	const header = (
		<span className="codeTreeBranchTitle">
			{checkbox}
			<span className="glyphicon glyphicon-triangle-right" aria-hidden="true"></span>
			{name}
		</span>
	);

	return (
		<Panel
			className={classnames('codeTreeItemPanel', { activeFilter: hasChildrenChecked || isChecked })}>
			<Panel.Heading>
				<Panel.Title toggle>{header}</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup className="codeTreeChildList">
					{childItems}
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

FilterByCodeItem.propTypes = {
	filterOptions: PropTypes.object,
	codeItem: PropTypes.shape({
		name: PropTypes.string,
		activityCodeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		activityCodeTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		children: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.array
		]),
		childrenSequence: PropTypes.array
	}),
	projectFilter: PropTypes.object,
	projectActivityCodesRelativesMap: PropTypes.object
};

export default FilterByCodeItem;
